import il8n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./translation/en.json";

const resources = {
  en: {
    translation: translationEN,
  },
  // ta is lazy-loaded via loadTamilTranslations() when the user switches language
};

il8n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Tamil translations are loaded lazily when the user switches language,
// keeping them out of the initial JS bundle.
export const loadTamilTranslations = async () => {
  if (!il8n.hasResourceBundle("ta", "translation")) {
    const { default: translationTA } = await import("./translation/ta.json");
    il8n.addResourceBundle("ta", "translation", translationTA);
  }
};

export default il8n;
